<mat-dialog-actions align="end">
  <mat-icon mat-dialog-close>close</mat-icon>
</mat-dialog-actions>

<mat-dialog-content>
  <dg-rule-list
    [appId]="appId"
    [ruleDate]="ruleDate"
    [isEditable]="isEditable"
  ></dg-rule-list>
</mat-dialog-content>
